import React from 'react'
import ReactModal from 'react-modal'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import MuiThemeProviderNext from 'material-ui-next/styles/MuiThemeProvider'
import { Router } from 'react-router'
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga'
import moment from 'moment'
import 'moment/locale/it'
import theme from './styles/swapickTheme'

import { createStore, compose, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './reducers'
import rootSaga from './saga'

import Swapick from './Swapick'
import { matchSomePaths, zendeskPaths } from './routes'

ReactModal.setAppElement('#root')

const sagaMiddleware = createSagaMiddleware()
const initialState = {
  cookieAccepted: !!window.localStorage.getItem('swapickCookieAccepted'),
}
const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(sagaMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)
sagaMiddleware.run(rootSaga)

// Global moment locale for stringify date ecc
moment.locale('it')

const history = createHistory()

// Show hide zend desk widgets when needed
const showHideZendDeskWhenNeeded = pathname => {
  // Stupid zend desk widgets not alredy loaded, nothing to do...
  if (
    typeof window.zE === 'undefined' ||
    typeof window.zE.show === 'undefined' ||
    typeof window.zE.hide === 'undefined'
  ) {
    return
  }

  if (matchSomePaths(pathname, zendeskPaths)) {
    window.zE.show()
  } else {
    window.zE.hide()
  }
}

if (process.env.NODE_ENV === 'production') {
  // integrate history \w Google Analytics
  ReactGA.initialize('UA-99374446-1')

  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname + location.search })
    ReactGA.pageview(location.pathname + location.search)
    showHideZendDeskWhenNeeded(location.pathname)
  })
}

const App = () => (
  <Provider store={store}>
    <Router history={history}>
      <MuiThemeProvider>
        <MuiThemeProviderNext theme={theme}>
          <Swapick />
        </MuiThemeProviderNext>
      </MuiThemeProvider>
    </Router>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js